import React, { useState } from 'react';
import { Button } from './Button';
import { Mail } from 'lucide-react';
export function EmailSignup() {
  const [email, setEmail] = useState('');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Email signup:', email);
    setEmail('');
  };
  return <div className="bg-[var(--color-gray-light)] py-20" data-id="element-23">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-24">
        <Mail size={48} className="mx-auto mb-6 text-[var(--color-primary)]" data-id="element-25" />
        <h2 className="text-[var(--color-text)] mb-4" data-id="element-26">Stay Connected</h2>
        <p className="text-lg text-[var(--color-text-light)] mb-8" data-id="element-27">
          Join our update list for project updates and stories from the field.
        </p>
        <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-4 max-w-md mx-auto" data-id="element-28">
          <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="Enter your email" required className="flex-1 px-6 py-3 rounded-md border-2 border-gray-300 focus:outline-none focus:border-[var(--color-primary)]" data-id="element-29" />
          <Button type="submit" variant="primary" data-id="element-30">
            Subscribe
          </Button>
        </form>
      </div>
    </div>;
}